import React, { useState } from 'react';
import readXlsxFile from 'read-excel-file';
import WarningIcon from '@material-ui/icons/Error';

import Modal from '../shared/modal/Modal';
import Button from '../shared/Button';
import Dropzone from '../shared/dropzone';
import { setAllocationStatuses } from '../../constants/enums';

const BulkUpdateModal = (props) => {
  const {
    open,
    onSubmit,
    onClose,
    loading,
    tenantColor,
  } = props;

  const [file, setFile] = useState(null);
  const [data, setData] = useState([]);

  const onRemove = () => {
    setFile(null);
  };

  const onFileChange = async (files) => {
    if (files && files.length) {
      setFile(files[0]);
    }
    const rows = await readXlsxFile(files[0]);
    if (rows && rows.length) {
      setData(rows);
    }
  }

  const handleSubmit = () => {
    const items = [...data];
    items.shift();
    onSubmit(items);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Update Items"
      fullWidth
    >
      <div className='upload-modal__container'>
        <div className='m-b-lg'>
          Please provide *.XLSX file for upload
        </div>
        <div>
          <div className='secondary m-b-md'>Format</div>
          <div className='modal-select align-center m-b-lg font-bold'>
            {['Item Code', 'Rebate Code', 'UDI', 'Value', 'Checklist Description', 'Batch Control (YES or NO)'].join(', ')}
          </div>
        </div>

        <Dropzone
          files={file ? [file] : []}
          onUpload={onFileChange}
          onRemove={onRemove}
          tenantColor={tenantColor}
          multiple={false}
          withoutProgress
        />

        {data?.length > 1000 && (
          <div className='d-flex m-t-lg'>
            <WarningIcon style={{ color: setAllocationStatuses.TRANSFERRED.color, marginRight: 4 }} />
            <span className='font-bold' style={{ color: setAllocationStatuses.TRANSFERRED.color }}>
                Uploading process may take several minutes. To avoid any data loss, do not close this window until upload has completed.
              </span>
          </div>
        )}

        <div className='upload-modal__actions'>
          <Button
            type='cancel'
            onClick={onClose}
          />
          <Button
            type='submit'
            text='Upload'
            disabled={loading || !data.length}
            loading={loading}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </Modal>
  );
};

export default BulkUpdateModal;
